import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import FormDroppableFunctions from "./FormDroppableFunctions";
import { MdDragIndicator } from "react-icons/md"; // optional drag icon

export default function FormDroppableItems({
	item,
	getInputType,
	activeInput,
	setActiveInput,
	setDroppedItems,
	active,
	setActive,
	allItems,
	isGhost,
	addForm,
	submitAttempt,
}) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({
		id: item.key,
	});
	console.log(
		"kkk",
		addForm?.values?.formSchema?.fields?.some(
			(i) => i.title === "" && i.key === activeInput
		)
	);
	const validationColor = () => {
		if (
			(submitAttempt &&
				(item?.title === "" ||
					(item.required.value === true &&
						item.required.validationMessage === ""))) ||
			(submitAttempt &&
				item?.container?.some(
					(i) =>
						i.title === "" ||
						(i.required.value === true && i.required.validationMessage === "")
				)) ||
			(submitAttempt && item?.container?.length === 0) ||
			(submitAttempt &&
				item?.dropdownOptions?.data &&
				Array.isArray(item.dropdownOptions.data) &&
				item.dropdownOptions.data.some(
					(opt) => opt.label === "" && opt.value === ""
				)) ||
			(submitAttempt &&
				item?.radioOptions &&
				Array.isArray(item.radioOptions) &&
				item.radioOptions.some(
					(opt) => opt.label === "" && opt.value === ""
				)) ||
			(submitAttempt &&
				item?.name === "Image" &&
				(item?.imgPath === null || item?.imgPath === "")) ||
			(submitAttempt &&
				item?.name === "Link" &&
				(item?.hyperLink === null || item?.hyperLink === ""))
		) {
			return "red";
		}
		return "#ccc";
	};

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		padding: "10px",
		marginBottom: "4px",
		border: "1px solid #ccc",
		borderRadius: "6px",
		backgroundColor: "#fff",
		opacity: isDragging ? 0.4 : 1,
		filter: isDragging ? "grayscale(100%)" : "none",
		cursor: "pointer",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		borderColor: validationColor(),
	};

	return (
		<div
			ref={setNodeRef}
			key={item.key}
			style={style}
			onClick={(e) => {
				e.stopPropagation();
				setActiveInput(item.key);
				setActive(true);
			}}
			className={
				activeInput === item?.key && active
					? "task-form-inputs-active"
					: "task-form-inputs"
			}
		>
			<div
				{...attributes}
				{...listeners}
				style={{ cursor: "grab", paddingRight: "8px" }}
				onClick={(e) => e.stopPropagation()}
				onMouseDown={(e) => {
					e.stopPropagation();
					setActiveInput(item.key);
					setActive(true);
				}}
				onTouchStart={(e) => {
					e.stopPropagation();
					setActiveInput(item.key);
					setActive(true);
				}}
			>
				<MdDragIndicator size={20} />
			</div>
			<div style={{ flexGrow: 1 }}>{getInputType(item)}</div>
			{activeInput === item.key && active && (
				<FormDroppableFunctions
					item={item}
					setDroppedItems={setDroppedItems}
					allData={allItems}
					containerKey={item.key}
				/>
			)}
		</div>
	);
}
